import { Feature } from "ol";
import { GPX } from "ol/format";
import { LineString, MultiLineString, Polygon } from "ol/geom";

const parser = new DOMParser();
const gpxFormat = new GPX();

export const getGpxFeatures = (gpxText: string | ArrayBuffer): Feature[] => {
    const xmlDoc = parser.parseFromString(gpxText as string, "application/xml");
    const geomTypes = getGpxTrackTypes(xmlDoc);
    const pointTypes = getGpxPointTypes(xmlDoc);
    const features = gpxFormat.readFeatures(gpxText, {
        dataProjection: "EPSG:4326",
        featureProjection: "EPSG:3059"
    });

    return parseGpxFeatures(features, geomTypes, pointTypes);
};

const getGpxTrackTypes = (xmlDoc: Document) => {
    const trksegTags = xmlDoc.getElementsByTagName("trkseg");
    const trackTypes: ("Polygon" | "LineString")[] = [];
    if (trksegTags?.length) {
        Array.from(trksegTags).map((trkseg) => {
            const points = Array.from(trkseg.getElementsByTagName("trkpt"));
            const geomType =
                points[0].getAttribute("lat") === points[points.length - 1].getAttribute("lat") &&
                points[0].getAttribute("lon") === points[points.length - 1].getAttribute("lon")
                    ? "Polygon"
                    : "LineString";
            trackTypes.push(geomType);
        });
    }

    return trackTypes;
};

const getGpxPointTypes = (xmlDoc: Document) => {
    const pointTags = xmlDoc.getElementsByTagName("wpt");
    const pointTypes = [];
    pointTags?.length &&
        Array.from(pointTags).map((point) => {
            const desc = point.querySelector("desc")?.innerHTML;
            pointTypes.push(desc ? desc : "Point");
        });

    return pointTypes;
};

const parseGpxFeatures = (features: Feature[], geomTypes, pointTypes) => {
    let pointNr = 0;
    let trackNr = 0;
    return features.map((feature) => {
        const geometry = feature.getGeometry();

        if (geometry.getType() === "MultiLineString") {
            geomTypes[trackNr] === "Polygon" &&
                feature.setGeometry(new Polygon((geometry as MultiLineString).getCoordinates()));
            geomTypes[trackNr] === "LineString" &&
                feature.setGeometry(new LineString((geometry as MultiLineString).getCoordinates().flat()));
            trackNr++;
        }

        if (geometry.getType() === "Point") {
            pointTypes[pointNr] !== "Point" && feature.set("description", pointTypes[pointNr]);
            pointNr++;
        }

        return feature;
    });
};
